export class SubscriptionCoupon {
  id: number;
  code: string;
  extraLessonsNumber: number;
  usedByUserid: number;
  usedByPurchasedSubscriptionId: number;

  public constructor(init?: Partial<SubscriptionCoupon>) {
    Object.assign(this, init);
  }
}
